import Chart from "chart.js/auto";

const backgroundPlugin = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart, args, options) => {
      const {ctx} = chart;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = options.color || '#fff';
      ctx.fillRect(0, 0, chart.width, chart.height);
      ctx.restore();
    }
};

export const truncateLabel = (str) => str.match(/.{1,25}(?:\s|$)/g)

export const radarChartConfig = {
    type: "radar",
    plugins: [backgroundPlugin],
    options: {
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 50,
            }
        },
        elements: {
            line: {
                borderWidth: 4,
            },
            point: {
                radius: 7,
                hoverRadius: 8,
            }
        },
        scales: {
            r: {
                suggestedMin: 0,
                suggestedMax: 5,
                ticks: {
                    stepSize: 1,
                    z: 1,
                },
                pointLabels: {
                    font: {
                      size: 16,
                    }
                },
                grid: {
                    color: 'rgba(66, 66, 66, 1)',
                },
                angleLines: {
                    color: 'rgba(107, 107, 107, 1)',
                }
            },
        },
        plugins: {
            customCanvasBackgroundColor: {
                color: '#fff',
            },
            title: {
                display: false,
            },
            legend: {
                position: 'right',
                align: 'start',
                labels: {
                    boxHeight: 0,
                    borderRadius: 100,
                    font: {
                        family: "Kufam",
                        size: 14,
                    }
                }
            },
            tooltip: {
                boxHeight: 1,
            }
        },
    },
}

export const barChartConfig = (title, scalesMin, scalesMax, scalesStepsize, percentage) => ({
    type: "bar",
    plugins: [backgroundPlugin],
    options: {
        layout: {
            padding: {
                right: 10,
            }
        },
        animation: false,
        scales: {
            y: {
                min: scalesMin || 0,
                max: scalesMax || 5,
                ticks: {
                    stepSize: scalesStepsize || 1,
                    format: {
                        style: percentage && 'percent'
                    }
                },
                grid: {
                    color: 'rgba(237, 237, 237, 1)',
                },
                
                
            },
      },
      plugins: {
            customCanvasBackgroundColor: {
                color: '#fff',
            },
            title: {
                display: true,
                text: title,
                font: {
                    family: "Kufam",
                }
            },
            legend: {
                display: false,
            }
        },
    },
})

export default {Chart, truncateLabel, radarChartConfig, barChartConfig};